export function formatAmount(
  value: string | number | null | undefined,
  fractionDigits = 0,
): string {
  const numericValue =
    typeof value === 'number'
      ? value
      : typeof value === 'string'
        ? Number(value.replace(/\s/g, '').replace(',', '.'))
        : NaN;

  if (!Number.isFinite(numericValue)) {
    return '0';
  }

  const formatted = numericValue.toLocaleString('ru-RU', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });

  return formatted.replace(/\u00A0/g, ' ');
}

export function formatCurrency(
  value: string | number | null | undefined,
  fractionDigits = 0,
): string {
  return `${formatAmount(value, fractionDigits)} ₽`;
}
